<template>
  <div>
    <template v-if="logged">
      <top-bar/>
      <div id="wrapper" >
        <left-menu/>
        <div id="page-content-wrapper" class="container-fluid">
            <router-view/>
        </div>
      </div>
    </template>
    <template v-else>
      <router-view/>
    </template>
  </div>
</template>

<script>
import userService from '@/service/userService'

export default {
  name: 'App',
  data: () => ({

  }),
  computed: {
    logged () {
      return userService.isLogged()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue